/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateAccountEntitlementsResult} from '../models/UpdateAccountEntitlementsResult';
import type {UpdateEntitlementsRelation} from '../models/UpdateEntitlementsRelation';

export interface BulkDischargeAccountEntitlements$Request {
    updateEntitlementsRelation: UpdateEntitlementsRelation;
    reason?: string;
}

export interface BulkDischargeAccountEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeAccountEntitlementsRequest = createAction<PayloadData<void, BulkDischargeAccountEntitlements$Request>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__REQUEST');
export const bulkDischargeAccountEntitlementsSuccess = createAction<PayloadData<string, BulkDischargeAccountEntitlements$Request>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__SUCCESS');
export const bulkDischargeAccountEntitlementsFailure = createAction<PayloadData<Error, BulkDischargeAccountEntitlements$Request, true>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__FAILURE');

export const bulkDischargeAccountEntitlementsActions = [
    bulkDischargeAccountEntitlementsRequest,
    bulkDischargeAccountEntitlementsSuccess,
    bulkDischargeAccountEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitlementsRelation} meta.updateEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeAccountEntitlements = (meta: BulkDischargeAccountEntitlements$Request, config?: BulkDischargeAccountEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkDischargeAccountEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeAccountEntitlementsProgress$Request {
    id: string;
}

export interface GetDischargeAccountEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeAccountEntitlementsProgressRequest = createAction<PayloadData<void, GetDischargeAccountEntitlementsProgress$Request>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_DISCHARGE_ACCOUNT_ENTITLEMENTS_PROGRESS__REQUEST');
export const getDischargeAccountEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetDischargeAccountEntitlementsProgress$Request>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_DISCHARGE_ACCOUNT_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getDischargeAccountEntitlementsProgressFailure = createAction<PayloadData<Error, GetDischargeAccountEntitlementsProgress$Request, true>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_DISCHARGE_ACCOUNT_ENTITLEMENTS_PROGRESS__FAILURE');

export const getDischargeAccountEntitlementsProgressActions = [
    getDischargeAccountEntitlementsProgressRequest,
    getDischargeAccountEntitlementsProgressSuccess,
    getDischargeAccountEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeAccountEntitlementsProgress = (meta: GetDischargeAccountEntitlementsProgress$Request, config?: GetDischargeAccountEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeAccountEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/entitlements/discharge/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeAccountEntitlementsResult$Request {
    id: string;
}

export interface GetDischargeAccountEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeAccountEntitlementsResultRequest = createAction<PayloadData<void, GetDischargeAccountEntitlementsResult$Request>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_DISCHARGE_ACCOUNT_ENTITLEMENTS_RESULT__REQUEST');
export const getDischargeAccountEntitlementsResultSuccess = createAction<PayloadData<UpdateAccountEntitlementsResult, GetDischargeAccountEntitlementsResult$Request>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_DISCHARGE_ACCOUNT_ENTITLEMENTS_RESULT__SUCCESS');
export const getDischargeAccountEntitlementsResultFailure = createAction<PayloadData<Error, GetDischargeAccountEntitlementsResult$Request, true>>('BULK_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_DISCHARGE_ACCOUNT_ENTITLEMENTS_RESULT__FAILURE');

export const getDischargeAccountEntitlementsResultActions = [
    getDischargeAccountEntitlementsResultRequest,
    getDischargeAccountEntitlementsResultSuccess,
    getDischargeAccountEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeAccountEntitlementsResult = (meta: GetDischargeAccountEntitlementsResult$Request, config?: GetDischargeAccountEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeAccountEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

